import { render, staticRenderFns } from "./page-create-breathing.vue?vue&type=template&id=26fd4f0a&"
import script from "./page-create-breathing.vue?vue&type=script&lang=ts&"
export * from "./page-create-breathing.vue?vue&type=script&lang=ts&"
import style0 from "./page-create-breathing.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports